define('views/modules/calendar/calendar-item-panel-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/events/calendar-events',
    // Views
    'src/views/form-view',
    'views/modules/calendar/calendar-item-menu-action',
    'views/modules/feedback/modal/feedback-modal-mixin',
    // Templates Blocks
    'text!templates/modules/calendar/calendar-item-panel-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    CalendarEvents,
    // Views
    VForm,
    VCalendarItemMenuAction,
    VFeedbackModalMixin,
    // Template
    TCalendarItemPanelContent
) {

    var CalendarItemPanelContent = VForm.extend(_.extend({
        template: TCalendarItemPanelContent,
        fields: ['done', 'date', 'feedback_level', 'feedback_comment'],

        regions: {
            root: ".calendar-item-panel-content",
            menu: ".menu-actions",
            content: ".content",
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                profile: opt.profile,
                role: opt.role,
                group: opt.group
            });

            var model = this.model,
                view = this.view = {
                    menu: new VCalendarItemMenuAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveClick,
                        item: model,
                        onDone: this.onDone,
                        radio: false,
                        tooltip: { container: this.regions.root, }
                    }),
                };

            this.listenTo(model, { 'change': this.onModelChange });
        },

        render: function() {
            this.initListener();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.getContentContext()), {
                content: this.contentTemplate
            }));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu);

            view.menu.toggleSaveButton(!this.isDirty());

            return this;
        },

        initListener: function() {
            this.stopListeningTo(CalendarEvents);
            this.listenTo(CalendarEvents, {
                'feedbackModal:change': this.onFeedbackModalChange,
                'toggle:done': this.onToggleDone,
            });
            return this;
        },

        toggleDone: function(value) {
            var model = this.model;
            model.toggleDone(value);
        },

        itemCanBeSaveWithoutValues: function(model) {
          if (model === undefined) {
            return false;
          } else {
              if (model.get("type") === "activity" && model.get('isFavorite') === true) return true;
          }
        },

        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onSaveClick: function() {
            this.submitFromSave = true;

            if (this.model.get('type') === "activity") {
                CalendarEvents.onActivitySaveClick();
            }

            var model = this.model;
            model.toggleDone(model.hasPassed());
            this.submit();
        },

        /////////////
        // events //
        /////////////

        onModelChange: function(model, options) {
          if (this.itemCanBeSaveWithoutValues(model)) {
            this.view.menu.toggleSaveButton(false);
          } else {
            this.view.menu.toggleSaveButton(!this.isDirty());
          }
        },

        onDone: function(opt) {
            opt = opt || {};
            this.toggleDone(opt.toggle);

            if (!this.model.isNew()) {
                this.submitFromSave = false;
                this.submit();
            }
        },

        onSuccess: function() {
            var model = this.model;
            if (model.isDone() && !this.modelMaster.isDone()) {
                _.delay(this.showFeedbackModal.bind(this), 500, model);
            }
        },

        onModelApplied: function() {
            if (this.submitFromSave) {
                this.trigger('save:button:form:success');
            }
            this.submitFromSave = false;
        },

        onFeedbackModalChange: function(model) {
            if (model.is(this.model)) {
                this.model.set(model.pick('feedback_level', 'done', 'feedback_comment'));
                this.applyModel();
            }
        },

        onToggleDone: function(model, value) {
            if (model.is(this.model)) {
                this.model.set('done', value);
                this.applyModel();
            }
        },

        ///////////////////
        // common events //
        ///////////////////

        onDisable: function() {
            this.stopListeningTo(CalendarEvents);
        },

        getContentContext: _.noop

    }, VFeedbackModalMixin));

    return CalendarItemPanelContent;

});

